import StorageProgressBar from './StorageProgressBar';
export default StorageProgressBar;

